import React, { useEffect,useState } from 'react';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import "./Blog.css";
import API from "../../Utils/Api";
import loader from "../../assests/loader.gif";

const Blog = () => {
  const [loading, setLoading] = useState(true);

  const [blog,setBlog] = useState([]);
  const [current_page,setCurrentpage] = useState(1); 
  const [last_page,setLastpage] = useState(1);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
    document.title = `Blog | Your Friend, My Friend`;
    document.getElementById('bodywrap').className = 'contact';

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute("content", "Get in touch with the YFMF team. We’re here to help with event bookings, app support, sponsorships and media enquiries.");
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });


    /* Start get blog */
    let formData = new FormData();
    formData.append("per_page", 6);
    API.post("get_all_blogs", formData)
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {
        } else {
            setLastpage(response.data.data.pagination.last_page);
            setBlog(response.data.data.blogs);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
    /* End get blog */

  }, []);

  const getblog = () => {
        setLoading(true);
        var currentpage=current_page+1;
        let formData = new FormData(); 
            formData.append(`per_page`, 6);
            formData.append(`page`, currentpage);
            API.post('get_all_blogs',formData)
                .then(response => {
                    setLoading(false);
                if(response.data.status === false){
                    
                }else{
                   setCurrentpage(currentpage);
                    setLastpage(response.data.data.pagination.last_page);
                    setBlog(prevBlog => [...prevBlog, ...response.data.data.blogs]);
                }                  
            }).catch(error => {
                setLoading(false); 
            });  
    }

  return (
    <>
      <Header />
      <div className="hello-worldss img-blog-head d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/blog.jpeg'}
          alt="blog"
          className="img-fluid d-none d-sm-block "
        />
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/blog-mobile.png'}
          alt="blog"
          className="img-fluid d-block d-sm-none"
        />
      </div>

      <div className="container-fluid blog upper">
        <div className="row">
          {blog.map((val, index) => {
            return (
              <div className="col-md-4 col-sm-6 mb-4">
                <div className="card h-100 d-flex flex-column">
                  <Link
                    to={`/blog-details/${val.id}`}
                    className="text-decoration-none"
                  >
                    <img
                      src={val.mobile_thumb}
                      className="card-img-top"
                      alt=""
                    />
                  </Link>
                  <div className="card-body d-flex flex-column">
                    <div className="mt-auto">
                      <Link
                        to="/blog-details"
                        className="text-decoration-none"
                      >
                        <h5>
                          {val.title}
                        </h5>
                      </Link>
                      <p>{val.subtitle}</p>
                    </div>
                    <Link
                      to={`/blog-details/${val.id}`}
                      className="text-decoration-none"
                    >
                      <div className="get-ti">
                        <Link
                          to={`/blog-details/${val.id}`}
                          className="w-100 text-decoration-none"
                        >
                          read more
                        </Link>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            );
          })}   
          {current_page !== last_page && (
            <div className='d-flex align-items-center justify-content-center'>
            <button className="load-mores" onClick={getblog}>
              Load more
            </button>
            </div>
          )}
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default Blog;
